const INITIAL = 'INITIAL';
const LOADING = 'LOADING';
const ERROR = 'ERROR';
const SUCCESS = 'SUCCESS';

const LoadingConstants = {
    INITIAL,
    LOADING,
    ERROR,
    SUCCESS,
};

export default LoadingConstants;
